import React from 'react';

const AddButton = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="4" fill="var(--SELECTED)" />
    <path
      d="M12.96 11.0416L12.9598 6.28635L12.9557 6.20124C12.8974 5.69311 12.4885 5.32653 12 5.32653C11.5064 5.32653 11.0947 5.70068 11.0451 6.18875L11.0408 6.2634L11.0404 11.0413L6.28479 11.0418L6.19888 11.046C5.72638 11.1006 5.37532 11.4569 5.32991 11.904L5.32556 11.9786L5.32575 12.028L5.32921 12.0875C5.38384 12.56 5.74009 12.911 6.1872 12.9564L6.26186 12.9608L11.0401 12.9609L11.0402 17.7168L11.0434 17.7914C11.0947 18.3025 11.5064 18.6766 12.0001 18.6766L12.0746 18.6735L12.1542 18.6624C12.6241 18.5786 12.9599 18.1845 12.9599 17.7168L12.9597 12.9612L17.7153 12.9614L17.7899 12.9582C18.3009 12.9069 18.6751 12.4953 18.6751 12.0016C18.6751 11.4715 18.2454 11.0418 17.7153 11.0418L12.96 11.0416Z"
      fill="#6933D3"
    />
  </svg>
);

export default AddButton;
